import { QueryClient } from '@tanstack/react-query'

// Module-level singleton so session teardown (src/lib/session.ts) can clear
// the cache without prop-drilling from main.tsx.
export const qc = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 3000 },
  },
})
